/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitTablesTableRow.module.scss';

const TableRow = forwardRef(({ children = null, className = '', testId = '' }, ref) => (
  <tr
    className={classnames(styles.element, className)}
    data-testid={testId}
    ref={ref}
  >
    {children}
  </tr>
));

TableRow.displayName = 'TableRow';

TableRow.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  testId: PropTypes.string,
};

export default TableRow;
